define('SC.ContactUsLandingPage.1.0.0.ContactUsLandingPage', [
    'ContactUsLandingPage.Router'
], function ContactUs(
    Router
) {
    'use strict';

    return {
        mountToApp: function mountToApp(application) {
            return new Router(application);
        }
    };
});
